appHost.actions.register({
    // #region Vars
    name: '288a.commerce.cart.rename',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            cartName: tCart.cartName,
            cartID: tCart.cartID
        };
        return this.Window(await appHost.notification.showModal2(appHost.components.getComponent('g-cart-create-dialog'), tArgs));
    },
    // #endregion
});
export {};
